import type { IError, IResponse, IResponseEvent } from "@core/data-access/model";
import { envConfig } from "@env/env-config";
import type {
    IAnonymousResponseUser,
    IAnonymousUserLoginService,
    PageCacheKey,
} from "@modules/basic/page";
import type { ICartRestService } from "@modules/cart/rest/cart-rest";
import type {
    IProductCatalog,
    productCatalogWithPagePath,
} from "@modules/catalog/product-catalog/model/domain/ProductCatalog";
import type { IProductCatalogRestService } from "@modules/catalog/product-catalog/rest/product-catalog-rest";
import type { HeaderObjectTreeService } from "./header-object-tree.service";
import type { IPermissionService } from "@modules/basic/page/page-service";
import type { ICatalogViewValue, ICurrencyObj, IHeadUrlParams } from "./header";
import { DefaultCatalogUtil } from "@modules/catalog/default-catalog-util";
import { UrlUtil } from "@core/utils";
import type { IEventBus } from "@core/event-bus/event-bus";
import type { PreferenceEditorResolveDefine } from "@modules/partner/model/domain/preference";
import type { ICurrencyRestService } from "@modules/partner/rest/currency/currency-rest";
import type { CurrencyCodeType } from "@modules/website/model/domain/currency";
import type { IEventBusParameter } from "@core/event-bus/event-bus-parameter";
import type { IPreferenceEditorService } from "@components/preference-editor/preference-editor.service";
import type { IMessageDialog } from "@qpUIs/qp-message-dialog/qp-message-dialog.interface";
import type { IUserDataService } from "@modules/user/service/data/i-user-data-service";
import { PageObjectTreeService } from "@modules/basic/page/page-object-tree.service";

export class HeaderController {
    public static $inject: Array<string> = [
        "headerObjectTree", "$scope", "$window",
        "pageContext", "productCatalogRestService",
        "cartRestService", "anonymousRestService",
        "$translate", "permissionService",
        "$filter", "urlBuilder", "$q",
        "$uibModal", "eventBus",
        "currencyRestService", "$timeout",
        "preferenceEditorService", "qpMessageDialog",
        "userDataService", "$objectTree"
    ];

    public userName: string;

    public currentPage: string;

    // public firstName: string;
    // user操作类表，展示
    public userOperationShow: boolean;

    public activeMenuItem: string;
    public parentMenuItem: string;
    public lastMenuName: string;
    public drawerUrl: string;
    public devDrawerUrl: string;
    public personalDrawerUrl: string;
    public productsDrawerUrl: string;
    // public cartNumber: number;
    public displayProductMenu: boolean = false;
    public displayResourcesMenu: boolean = false;
    public productCatalogList: any[];
    public isFetchedCatalogData: boolean = false;
    // 是否展开产品子目录
    private expand: boolean;

    private homePage: string;
    private qpmnDomain: string;


    // 导航栏选中高亮-当前页面标识
    public selectedPage: string;

    // user导航是否显示dashboard链接
    public showDashboardLink: boolean = false;

    // 默认产品分类路径
    private defaultCatalogUrl: string;

    // 产品分类__缓存15分钟 
    private CATALOG_CACHE_TIME: number = 900 * 1000; // (转换为ms)
    // common-header
    private commonHeaderUrl: string;
    // header页面导航
    private navigationsUrl: string;

    // logo_pc
    private logoPcUrl: string;
    // logo_mobile
    private logoMobileUrl: string;
    // catalog-list模板地址
    private catalogListUrl: string;


    public get isLogin() {
        let currentDateTimeStamp = new Date().getTime();
        let expireTimeStamp = this.headerObjectTree.getCache("expire") == "" ? 0 : this.headerObjectTree.getCache("expire");
        // 非匿名用户且过期时间戳未超过当前日期时间戳
        return !this.headerObjectTree.isAnonymous() && currentDateTimeStamp < Number(expireTimeStamp);
    }

    public get cartNumber() {
        return this.headerObjectTree.getCache("CartNumber") != null ? Number(this.headerObjectTree.getCache("CartNumber")) : 0;
    };

    public set cartNumber(cartNumber: number) {
        this.headerObjectTree.setCache("CartNumber", String(cartNumber));
    }

    // 这里的firstName指的是用户名称
    public get firstName() {
        return this.headerObjectTree.getCache("firstName") != null ? this.headerObjectTree.getCache("firstName") as string : "";
    }

    public set firstName(nickName: string) {
        this.headerObjectTree.setCache("firstName", nickName);
    }

    public get isinline(): boolean {
        // 获取URL参数
        const urlParams = this.urlBuilder.getUrlParameters<IHeadUrlParams>();
        if (!urlParams) {
            return false;
        }
        return urlParams.isinline ?? false;
    }

    public get preferenceCurrencyCodeViewer(): CurrencyCodeType | "" {
        if (this.preferenceEditorService.userPreference.currencyCode) {
            return "(" + this.preferenceEditorService.userPreference.currencyCode + ")";
        } else {
            return "";
        }
    }
    private rootPath: string;

    private catalogViewValue: ICatalogViewValue;

    // public errorBoxContent: string = "";
    constructor(
        public headerObjectTree: HeaderObjectTreeService,
        public $scope: angular.IScope,
        public $window: angular.IWindowService,
        public pageContext: qpmn.main.IPageContext,
        public productCatalogRestService: IProductCatalogRestService,
        public cartRestService: ICartRestService,
        public anonymousRestService: IAnonymousUserLoginService,
        public $translate: angular.translate.ITranslateService,
        public permissionService: IPermissionService,
        public $filter: angular.IFilterService,
        public urlBuilder: qpmn.common.rest.IUrlBuilderService,
        public $q: angular.IQService,
        public $uibModal: angular.ui.bootstrap.IModalService,
        public eventBus: IEventBus,
        public currencyRestService: ICurrencyRestService,
        public $timeout: angular.ITimeoutService,
        public preferenceEditorService: IPreferenceEditorService,
        public qpMessageDialog: IMessageDialog,
        public userDataService: IUserDataService,
        public $objectTree: PageObjectTreeService
    ) {
        this.rootPath = this.pageContext.rootPath;
        // this.firstName = this.headerObjectTree.getFirstName();
        this.userOperationShow = false;

        this.activeMenuItem = "0";

        this.homePage = envConfig.getHomePage(this.rootPath);
        // 获取得到 https://sz-nginx-test1.qppdev.com/ 则为正确，本地ip获取待解决
        this.qpmnDomain = envConfig.getPath("", "");

        this.drawerUrl = this.pageContext.rootPath + "menu/index.html";
        this.devDrawerUrl = this.pageContext.rootPath + "dev-menu/index.html";
        this.personalDrawerUrl = this.pageContext.rootPath + "personal-menu/index.html";
        // this.productsDrawerUrl = this.pageContext.rootPath + "products-menu/index.html";
        // 设置catalog-list模板地址
        this.catalogListUrl =
            this.pageContext.rootPath + "catalog-list/index.html";

        // $templateRequest(angular.isFunction(setting.templateUrl) ? setting.templateUrl() : setting.templateUrl);s

        // 监听mobile侧边栏开启/关闭,当侧边栏开启时,禁用浏览器滚动条
        this.$scope.$watch("menuIsOpen", (newVal, oldVal) => {
            if (newVal == oldVal) {
                return;
            }
            if (newVal) {
                angular.element(document).find("body").addClass("menu-open");
            } else {
                angular.element(document).find("body").removeClass("menu-open");
            }
        })

        this.$objectTree.setUserDataService(this.userDataService);
    }

    /**
     * @description 用户登录
     */
    public logIn() {
        this.$window.location.href = this.pageContext.rootPath + "partner/login/" + "?" + encodeURIComponent(location.href);
    }

    /**
     * @description 获取用户注册页面地址
     */
    public getRegistUrl(): string {
        return this.pageContext.rootPath + "partner/regist/" + "?" + encodeURIComponent(location.href);
    }

    /**
     * @description 退出登录
     */
    public signOut() {
        // 清除登录缓存
        this.headerObjectTree.clearLogin();

        // 获取匿名用户id, 如果发起请求的anonymousUserId为 0 则表示新建匿名用户
        let anonymousUserId: number = this.headerObjectTree.getAnonymousUserId() || 0;

        this.anonymousRestService.login(anonymousUserId).then((tokenResp: IResponse<IAnonymousResponseUser>) => {
            // Token信息存至缓存          
            this.headerObjectTree.setAnonymousLogin({
                token: tokenResp.data.access_token,
                tokenType: tokenResp.data.token_type,
                isAnonymous: true,
                anonymousUserId: tokenResp.data.abc,
                expire: tokenResp.data.expires_in,
            })
        }, (failResp) => {
            // todo: 异常处理
            // console.warn(failResp);
            this.permissionService.onRequestFailed(failResp);
        }).finally(() => {
            // this.$window.location.href = this.pageContext.rootPath;
            this.$window.location.href = this.homePage;
        })
    }

    /**
     * @description 获取当前页面
     */
    public getCurrentPage(): string {
        // TODO
        // let pathName = window.location.pathname;
        let patt = /\/(\w+).html|\/([a-zA-Z0-9-]+).html/;

        let matched = patt.exec(window.location.pathname);

        if (matched && matched.length > 0) {
            return matched[1] || matched[2];
        } else {
            return ""
        }
    }

    /**
     * @deprecated
     */
    private setMenuWatch() {
        // 监听header头部“product”通过鼠标移入状态修改“产品类目二级导航”显示状态（displayProductMenu），获取产品类目数据
        this.$scope.$watch("headerCtrl.displayProductMenu", (newVal, oldVal) => {
            if (newVal == oldVal) {
                return;
            }
            // 鼠标移出时,不作任何处理
            if (newVal == false) {
                return;
            }

            const catalogExpire = `CatalogList-Expire` as PageCacheKey;
            let expireT = this.headerObjectTree.getCache(catalogExpire);
            let expireTime: number = 0;

            if (expireT != null && expireT != undefined) {
                expireTime = Number(expireT);
            }
            const catalogKey = `CatalogList` as PageCacheKey;

            let list = this.headerObjectTree.getCache(catalogKey);
            // 获取默认类目
            const defaultCatalog = this.headerObjectTree.getCache("DefaultCatalog");
            if (expireTime < new Date().getTime() || !list || !defaultCatalog) {
                this.fetchProductCatalogData();
            } else {
                if (list) {
                    this.productCatalogList = angular.fromJson(list);
                }
                if (defaultCatalog) {
                    // 设置默认类目信息
                    DefaultCatalogUtil.getDefaultCatalog(this.headerObjectTree, this.$q)
                        .then((res) => {
                            this.defaultCatalogUrl = UrlUtil.joinUrl([this.pageContext.rootPath, res.customizePath, (res.defaultCatalog as productCatalogWithPagePath).pagePath]);
                        }, error => {
                            // this.permissionService.onRequestFail(error);
                            this.permissionService.onRequestFailed(error);

                        })
                }
            }
        })
    }

    /**
     * @description 初始化
     */
    public $onInit() {
        this.scrollToFixed();
        this.selectedNavigation();
        this.switchUserTabs();

        this.currentPage = this.getCurrentPage();
        // this.cartRestService.totalQty().then(res => {
        //     if (res && res.success) {
        //         this.cartNumber = res.data.itemsQty
        //     }
        // }, (error) => {
        //     // this.permissionService.onRequestFail(error);
        //     this.permissionService.onRequestFailed(error);
        // })
        this.preferenceEditorService.use(this.$objectTree.getCurrentPreference());
        this.$objectTree.userPreference.then(res => {
            this.cartNumber = res.cartNumber;
            // console.log("init res", res)
            this.preferenceEditorService.updatePreference(res);
        });
        this.eventBus.addEventListener("UpdateCurrency", this.updatePartnerCurrency, this);
    }
    public $destroy() {
        this.eventBus.removeEventListener("UpdateCurrency", this.updatePartnerCurrency, this);
    }
    /**
     * @description 更新用户货币偏好
     * */
    public updatePartnerCurrency(params: IEventBusParameter<ICurrencyObj>) {
        const currencyObj = params.args;
        // __DEV__
        // console.log("currencyObj.code", currencyObj.code)
        let hasChange = 0;
        const preferenceTemplate = { ...this.preferenceEditorService.userPreference }
        // 1. diff 货币类型选项
        if (currencyObj.code !== preferenceTemplate.currencyCode) {
            preferenceTemplate.currencyCode = currencyObj.code;
            hasChange += 1;
        }
        // 2. 更新

        if (hasChange) {
            console.log("update preference", preferenceTemplate);
            this.$objectTree.setCurrentPreference(preferenceTemplate);
            // this.$window.location.reload();
        }
        this.preferenceEditorService.updatePreference(preferenceTemplate);
    }

    /**
     * @deprecated
     * @param productCatalogList 
     * @returns 
     */
    public combineCatalogUrlPath(productCatalogList: productCatalogWithPagePath[]) {
        let pagePathStr: string;
        productCatalogList.forEach(productCatalog => {
            if (productCatalog.parent) {
                let parentCatalogItem = productCatalogList.find((ele) => {
                    if (productCatalog.parent) {
                        return ele.id == productCatalog.parent.id;
                    }
                })
                pagePathStr = productCatalog.catalog.pageName;
                if (parentCatalogItem) {
                    productCatalog.pagePath = parentCatalogItem.catalog.pageName + '/' + pagePathStr;
                }
            } else {
                pagePathStr = productCatalog.catalog.pageName;
                productCatalog.pagePath = pagePathStr + '/all';
            }
        })
        return productCatalogList;
    }

    /**
     * @description 重置当前匿名
     * 
     * @param successCallback 
     * @param failCallback 
     */
    public resetAnonymousToken(successCallback?: Function, failCallback?: Function) {
        // 获取匿名用户id, 如果发起请求的anonymousUserId为 0 则表示新建匿名用户
        let anonymousUserId: number = this.headerObjectTree.getAnonymousUserId() || 0;

        this.anonymousRestService.login(anonymousUserId).then((tokenResp: IResponse<IAnonymousResponseUser>) => {
            // Token信息存至缓存
            // this.headerObjectTree.setLogin({
            //     firstName: tokenResp.data.firstName,
            //     userName: tokenResp.data.username,
            //     token: tokenResp.data.access_token,
            //     tokenType: tokenResp.data.token_type,
            //     isAnonymous: true,
            //     anonymousUserId: tokenResp.data.anonymousUserId,
            //     expire: tokenResp.data.expires_in,
            //     partnerType: tokenResp.data.partnerType,
            // })
            this.headerObjectTree.setAnonymousLogin({
                token: tokenResp.data.access_token,
                tokenType: tokenResp.data.token_type,
                isAnonymous: true,
                anonymousUserId: tokenResp.data.abc,
                expire: tokenResp.data.expires_in,
            })
            if (successCallback) {
                successCallback();
            }
            // TODO: 是否需要reload
            window.location.reload();
        }, (failResp) => {
            // 登录失败处理
            //TODO userId不存在处理,暂时未知什么原因会导致这个问题发生,在这做兼容处理,userId不存在时,重新执行匿名登录,后续通过Sentry采集异常
            if (failResp.status === 200 && failResp.data && !angular.isUndefined(failResp.data.success) && !failResp.data.success && !angular.isUndefined(failResp.data.data.code) && failResp.data.data.code === 3000001) {
                // 清除缓存中记录的匿名用户id
                this.headerObjectTree.removeCache("AnonymousUserId");
                // 重新登录
                this.resetAnonymousToken(successCallback, failCallback);
            } else {
                this.requestFail(failResp);
            }
        })
    }
    private readonly PROMPT_DEFAULT_CONFIG = {
        // 是否反向显示confirm和取消按钮
        reverseButtons: true,
        // 是否显示取消按钮
        showCancelButton: false,
        // 取消按钮的自定义class类
        cancelButtonClass: 'alert-login-cancel',
        // 确认按钮的自定义class类
        confirmButtonClass: 'alert-login-confirm',
        // 为按钮添加默认的swal2样式
        buttonsStyling: true,
        // 是否允许点击对话框外部来关闭对话框
        allowOutsideClick: false,
        // 是否允许按下Esc键来关闭对话框
        allowEscapeKey: false,
        title: "Permission invalid",
        content: "Go to login?",
        cancelButtonText: "CANCEL",
        confirmButtonText: "OK"
    }
    private getAllCatalog() {
        this.productCatalogRestService.getAll()
            .then(res => {
                //根据产品类目优先级进排序（sortOrder有大到小排列）
                let productCatalogData = res.data;
                productCatalogData = this.$filter('orderBy')(productCatalogData, 'sortOrder', true);
                for (let i = 0; i < productCatalogData.length; i++) {
                    let catalogData = productCatalogData[i];
                    //TODO（待替换为pageNameFilter） pageName去除“.html”
                    catalogData.catalog.pageName = catalogData.catalog.pageName.replace('.html', '');
                }
                this.productCatalogList = this.combineCatalogUrlPath(productCatalogData as unknown as productCatalogWithPagePath[]);
                this.productCatalogList = this.formatArrToTree(this.productCatalogList);
                this.productCatalogList.forEach(productCatalog => {

                    if (productCatalog.children) {
                        productCatalog.expand = false;
                    }
                })
                // 设置产品类目缓存
                const catalogKey = `CatalogList` as PageCacheKey;
                this.headerObjectTree.setCache(catalogKey, angular.toJson(this.productCatalogList));
            }, (error) => {
                // this.permissionService.onRequestFail(error);
                this.permissionService.onRequestFailed(error);
            })
    }
    private requestFail(e) {
        if (e.status == 401) {
            // 检查当前是否是实名用户
            const isAnonymous = this.headerObjectTree.isAnonymous();
            // 匿名用户处理
            if (isAnonymous) {
                this.resetAnonymousToken();
            } else {
                let config = angular.copy(this.PROMPT_DEFAULT_CONFIG);
                config.showCancelButton = true;
                // this.$translate.instant(error.code)
                // 权限不足标题
                const authTitle = this.$translate.instant("A107B002");
                // 提示文本
                const authContent = this.$translate.instant("A107B003");
                // 实名用户处理
                window.qpAlertPrompt.question(authTitle, authContent, {
                    fn: () => {
                        this.headerObjectTree.setAnonymous(true);
                        // 记录当前页面地址并跳转至登录页
                        window.location.href = `${this.pageContext.rootPath}/partner/login/?${encodeURIComponent(location.href)}`;
                    }
                }, { fn: () => { this.resetAnonymousToken(); } }, config);
            }
        }
    }
    /**
     * @deprecated
     * @returns 
     */
    public fetchProductCatalogData(): void {
        if (this.isFetchedCatalogData) {
            return;
        }
        this.isFetchedCatalogData = true;
        this.productCatalogRestService.getAll()
            .then(res => {
                //根据产品类目优先级进排序（sortOrder有大到小排列）
                let productCatalogData = res.data;
                productCatalogData = this.$filter('orderBy')(productCatalogData, 'sortOrder', true);
                for (let i = 0; i < productCatalogData.length; i++) {
                    let catalogData = productCatalogData[i];
                    //TODO（待替换为pageNameFilter） pageName去除“.html”
                    catalogData.catalog.pageName = catalogData.catalog.pageName.replace('.html', '');
                }
                this.productCatalogList = this.combineCatalogUrlPath(productCatalogData as unknown as productCatalogWithPagePath[]);
                this.productCatalogList = this.formatArrToTree(this.productCatalogList);
                this.productCatalogList.forEach(productCatalog => {
                    if (productCatalog.children) {
                        productCatalog.expand = false;
                    }
                })
                // 设置产品类目缓存
                const catalogKey = `CatalogList` as PageCacheKey;
                this.headerObjectTree.setCache(catalogKey, angular.toJson(this.productCatalogList));
                // 查询默认类目
                return DefaultCatalogUtil.getDefaultCatalog(this.headerObjectTree, this.$q);
            })
            .then((res) => {
                // 设置默认产品类目
                this.defaultCatalogUrl = UrlUtil.joinUrl([this.pageContext.rootPath, res.customizePath, (res.defaultCatalog as productCatalogWithPagePath).pagePath]);
                const catalogExpire = `CatalogList-Expire` as PageCacheKey;
                this.headerObjectTree.setCache(catalogExpire, (new Date().getTime() + this.CATALOG_CACHE_TIME).toString());
            })
            .catch(error => {
                this.permissionService.onRequestFailed(error);
                // this.permissionService.onRequestFail(error);
            })
            .finally(() => {
                this.isFetchedCatalogData = false;
            })
    }
    /**
     * @deprecated
     * @param array 
     * @returns 
     */
    public formatArrToTree(array) {
        const map = {};
        array.forEach(catalog => {
            map[catalog.id] = catalog;
        });
        const CatalogList = <any>[];
        array.forEach(Catalogitem => {
            if (Catalogitem.parent) {
                if (map[Catalogitem.parent.id]) {
                    if (!map[Catalogitem.parent.id]?.children) {
                        map[Catalogitem.parent.id].children = [Catalogitem];
                    } else {
                        map[Catalogitem.parent.id].children.push(Catalogitem);
                    }
                }
            } else {
                CatalogList.push(Catalogitem);
            }
        });
        return CatalogList
    }
    /**
     * @description 页面跳转
     * */
    // TODO 临时写法，待验证
    public jumpPage(url?: string) {
        let _url = url || "";
        this.$window.location.href = this.pageContext.rootPath + _url;
        this.selectedNavigation();
        this.switchUserTabs();
    }

    /**
    * @description 选中products导航，增加选中色
    */
    public selectedNavigation() {
        let urlParam = window.location.pathname.split('/');

        if (urlParam.includes('customize')) {
            this.selectedPage = "Catalog";
        }

    }
    /**
     * @description 滚动变固定定位
     */
    public scrollToFixed() {
        // 添加滚动事件监听
        this.$window.addEventListener("scroll", () => {
            let headerObj = document.getElementById("fixed-header");
            if (headerObj) {
                if (window.pageYOffset > headerObj.offsetTop) {
                    headerObj.classList.add("sticky-header");
                } else {
                    headerObj.classList.remove("sticky-header");
                }
            }
        });
    }
    /**
     * @description 切换user的子导航(homepage,dashboard)
     */
    public switchUserTabs() {
        let urlParam = window.location.pathname.split('/');
        if (urlParam.includes('dashboard')) {
            this.showDashboardLink = false;
        } else {
            this.showDashboardLink = true;
        }
    }

    /**
     * @description 打开偏好设置
     */
    public openPreferenceEditor() {
        // do clean post data
        // if (this.$timeout.cancel(this.cleanTimerPromise)) {
        //     this.errorBoxContent = "";
        // };
        this.preferenceEditorService.openPreferenceEditor<ICurrencyObj>(this.$uibModal,
            <PreferenceEditorResolveDefine>{
                selectCurrencyCode: () =>
                    this.preferenceEditorService.userPreference.currencyCode,
                onRequestFailed: () =>
                    this.permissionService.onRequestFailed.bind(this.permissionService),
                savePreference: () =>
                    this.userDataService.updateUserPreference.bind(this.userDataService),
            }).then((selectedCurrency) => {
                if (this.preferenceEditorService.diff(selectedCurrency)) {
                    // __DEV__
                    console.log("header emit preference", selectedCurrency);
                    this.eventBus.dispatch("UpdateCurrency", selectedCurrency);
                }
            }).catch((reason?: { $message?: string; $reason: string }) => {
                if (!reason || !reason.$message)
                    return;
                this.qpMessageDialog.info({
                    title: reason.$reason,
                    content: reason.$message,
                });
                // set Error Message
                // this.errorBoxContent = reason.$value;
                // this.cleanTimerPromise = this.$timeout(() => {
                //     this.errorBoxContent = "";
                // }, 2000);
            });
    }
}
